<template>
  <t-text-field
    :id="field"
    v-model="value"
    v-bind="{ ...$attrs }"
    :class="[`field-${field}`]"
    name="address-city"
    :autocomplete="autocomplete"
    :error-messages="errors"
    :placeholder="placeholder"
    outlined
    :autofocus="autofocus"
    :loading="loading"
    :success="isValid"
    @blur="validate(value)"
  />
</template>

<script>
import ValidationError from 'chimera/all/functions/ValidationError'
import AbstractFormField from 'chimera/all/components/form/fields/AbstractFormField'

export const field = 'address-city'
export default {
  name: 'AddressCityField',

  extends: AbstractFormField,

  props: {
    field: {
      type: String,
      default: field,
    },

    autofocus: {
      type: Boolean,
      default: false,
    },

    autocomplete: {
      type: String,
      default: 'address-level2',
    },

    placeholder: {
      type: String,
      default: 'Woonplaats',
    },
  },

  /**
   * Component state
   *
   * @returns {object}
   */
  data() {
    return {
      value: '',
    }
  },

  methods: {
    /**
     * @returns {*[]}
     */
    customErrorMap() {
      return [
        {
          id: ValidationError.reasonIsRequired,
          message: this.$i18n.t('field.address-city.validation.required'),
        },
        {
          id: ValidationError.reasonInvalidRegex,
          message: this.$i18n.t('field.address-city.validation.invalid'),
        },
        {
          id: ValidationError.reasonInvalidLength,
          message: this.$i18n.t('field.address-city.validation.invalid'),
        },
        {
          id: ValidationError.reasonInvalidValue,
          message: this.$i18n.t('field.address-city.validation.invalid'),
        },
      ]
    },
  },
}
</script>
